import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/career`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all career opportunities with pagination
export const  fetchCareerTable = async (page: number, limit: number) => {
  const response = await axios.get(`${API_URL}/table?page=${page}&limit=${limit}`, { headers: customHeaders });
  return response.data;
};

// Fetch all career opportunities
export const fetchCareers = async () => {
  const response = await axios.get(API_URL, { headers: customHeaders });
  return response.data;
};

// Fetch a career opportunity by ID
export const fetchCareerById = async (id: string) => {
  const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};

// Create a new career opportunity
export const addCareer = async (newCareer: { role: string; location: string; employment_type: string }) => {
  const response = await axios.post(API_URL, newCareer, { headers: customHeaders });
  return response.data;
};

// Edit an existing career opportunity
export const updateCareer = async (id: string, updatedCareer: { role: string; location: string; employment_type: string }) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedCareer, { headers: customHeaders });
  return response.data;
};

// Delete a career opportunity
export const removeCareer = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`, { headers: customHeaders });
  return response.data;
};
